(function (angular) {
    'use strict';
    var app = angular.module('enervee.fastTrack');

    /*
     Creates a new controller for the rebate Fast Track form success modal
     */
    app.controller('fastTrackSuccessModalCtrl', [
        '$uibModalInstance',
        'AnalyticsService',
        'initialScope',
        function (
            $uibModalInstance,
            AnalyticsService,
            initialScope
        ) {
            var vm = this;

            vm.dismissModal = function () {
                $uibModalInstance.dismiss('cancel');
                AnalyticsService.reportEvent('Fast Track Completed');
            };
        }
    ]);

})(angular);
